import React from 'react';
import { TextLink } from '../../components/Link';
import { Logo } from '../../components/Logo';
import { SvgIcon } from '../../components/SvgIcon';
import { selectSysLanguageIsocode } from '../../provider/Typo3Provider/selectors';
import { MenuEntry } from '../../provider/Typo3Provider/types';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';

interface LogoContainerProps {
  root?: MenuEntry;
}

const LogoContainer = ({
  root,
  typo3
}: LogoContainerProps & WithTypo3Props) => {
  const sysLanguageIsocode = selectSysLanguageIsocode(typo3);

  return (
    <TextLink to={root ? root.link : '/'}>
      <Logo>
        <SvgIcon icon={sysLanguageIsocode === 'fr' ? 'logo_fr' : 'logo'} />
      </Logo>
    </TextLink>
  );
};

export default withTypo3(LogoContainer);
